import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

import Contact from '@/components/Contact'
import Friends from '@/components/Friends'

import Game_1 from '@/components/Game_1'
import Game_2 from '@/components/Game_2'
import Game_3 from '@/components/Game_3'
import Game_4 from '@/components/Game_4'
import Game_5 from '@/components/Game_5'
import Game_6 from '@/components/Game_6'
import Game_7 from '@/components/Game_7'
import Game_8 from '@/components/Game_8'
import Game_9 from '@/components/Game_9'
import Home from '@/components/Home'

import Gallery from '@/components/Gallery'
Vue.use(Router)

export default new Router({
    routes:[
        {
            path:'/',
            name: 'home',
            component:Home
        },
        {
            path:'/friends',
            name: 'Friends',
            component:Friends
        },
        {
            path:'/contact',
            name: 'contact',
            component:Contact
        },
        {
            path:'/game_1',
            name: 'game_1',
            component:Game_1,
        },
        {
            path:'/game_2',
            name: 'game_2',
            component:Game_2
        },
        {
            path:'/game_3',
            name: 'game_3',
            component:Game_3
        },
        {
            path:'/game_4',
            name: 'game_4',
            component:Game_4
        },
        {
            path:'/game_5',
            name: 'game_5',
            component:Game_5
        },
        {
            path:'/game_6',
            name: 'game_6',
            component:Game_6
        },
        {
            path:'/game_7',
            name: 'game_7',
            component:Game_7
        },
        {
            path:'/game_8',
            name: 'game_8',
            component:Game_8
        },
        {
            path:'/game_9',
            name: 'game_9',
            component:Game_9
        },
        {
            path:'/home',
            name: 'home',
            component:Home
        },
        {
            path:'/gallery',
            name: 'gallery',
            component:Gallery
        },

    ]
})